import JoditEditor from 'jodit-react';
import React, { useRef } from 'react';

const AddProjectInfo = () => {
    const editor = useRef(null);
    const config = {
        buttons: ["bold", "italic", "link", "unlink", "underline", "source" ,"lineT"],
        style: {
          height:'450px',
          width:'80%',
          matgin:"auto",
          background: '#27272E',
          color: 'rgba(255,255,255,0.5)',
      },

     

      };

       // handle submit 

       const handleSubmit = (e) => {
        e.preventDefault()
        const form = e.target.data.value
        const data = {
          form
        }
        console.log(JSON.stringify(data))
        
       }
    return (
       <form  onSubmit={handleSubmit}>
         <JoditEditor
        ref={editor}
       name="data"
        config={config}
        tabIndex={1}
        
        
      />
      <input type="submit" value="submit" />
       </form>
    );
};

export default AddProjectInfo;